import * as App from '../constants/App';
import axios from 'axios';
// import '../constants/AppSettings'
import * as SG from '../constants/AppSettings'
import { getCreditCardInfo } from './User/Credit'
import { addNotification as notify } from 'reapop'
export function loadStart() {
  return {
    type: App.LOAD_START
  }
}

export function loadEnd() {
  return {
    type: App.LOAD_END
  }
}

export function userSignOut() {
  window.localStorage.removeItem('token')
    return {
      type: App.USER_APP_SIGN_OUT
    }
  
}

export function signOutResult(noticeAdd) {
  return {
    type: App.USER_APP_SIGN_OUT,
    noticeAdd: noticeAdd
  }
}

export function signOutReset() {
  return {
    type: App.USER_SIGN_OUT_RESET
  }
}


export function signInCheck() {
  return dispatch => {
    dispatch(signInCheckRequest());

    axios.get(SG.API_SIGN_IN_CHECK_URL, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).then(response => {
      dispatch(signInCheckResult(response));
      dispatch(loadEnd())
      if (response.status === 200) {
        // ログインしたとき
        dispatch(getCreditCardInfo())
        return {
          type: App.USER_SIGN_IN_CHECK,
          user: response.data.user,
          signIn: true
        };
      } else {
        return {
          type: App.USER_SIGN_IN_CHECK,
          user: null,
          signIn: false,
        }
      }
    }).catch(response => {
      dispatch(loadEnd())
      dispatch(signInCheckResult(response));
      return {
        type: App.USER_SIGN_IN_CHECK
      };
    })
    
  }
}

export function signInCheckRequest() {
  return {
    type: App.USER_SIGN_IN_CHECK_REQUEST
  }
}

export function signInCheckResult(result) {
  // console.log('signInCheckResult', result)
  return {
    type: App.USER_SIGN_IN_CHECK_RESULT,
    result
  }
}

export function jsLoad() {
  return {
    type: App.HEADER_JS_SETED
  }
}

export function noticeAdd(infoMsg = null, infoMsgType = null) {
  if (infoMsg === null || infoMsgType === null) {
    infoMsg = null
    infoMsgType = null
  }

  return dispatch => {

    const isArray = Object.prototype.toString.call(infoMsg) === '[object Array]'
  
    if (!isArray) {
      infoMsg = [infoMsg]
    }

    for (let index = 0; index < infoMsg.length; index++) {
      const msg = infoMsg[index];

    
      dispatch(notify({
        message: msg,
        status: infoMsgType,
        dismissible: true,
        closeButton: true,
        allowHTML: true,
      }))
    
    }
    
  }


}

export function noticeRemove() {
  return {
    type: App.NOTICE_REMOVE
  }
}

export function notificationGet(page=1, size=10) {
  return dispatch => {
    // dispatch(loadStart())
    axios.get(SG.NOTIFICATION_INDEX_URL+`?page=${page}&size=${size}`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).then(res => {
      dispatch(notificationGetResult(res.data))
      // dispatch(loadEnd())
    }).catch(res => {
    })
  }
}

export function notificationGetResult(notifications) {
  return {
    type: App.NOTIFICATION_GET_RESULT,
    notificationGetResult: notifications
  }
}

export function notificationRead(idsStr) {
  return dispatch => {
    axios.post(SG.NOTIFICATION_READ_URL, {
          notification_ids: idsStr
        }, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
      }).then(res => {
        dispatch(notificationUnreadGet())
    })
    dispatch(notificationGetReset())
  }
  // return {
  //   type: App.NOTIFICATION_READ,
  //   ids: ids
  // }
}

export function notificationUnreadGet() {
  return dispatch => {
    // dispatch(loadStart())
    axios.get(SG.NOTIFICATION_UNREAD_URL, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).then(res => {
      // dispatch(notificationUnreadGetResult())
      // dispatch(loadEnd())
      dispatch(notificationUnreadGetResult(res.data.count))
    }).catch(res => {
      // dispatch(loadEnd())
      // dispatch(notificationUnreadGetResult())
    })
  }
}

export function notificationUnreadGetResult(unreadCount) {
  return {
    type: App.NOTIFICATION_UNREAD_GET_RESULT,
    unreadCount: unreadCount
  }
}

export function notificationGetReset() {
  return {
    type: App.NOTIFICATION_GET_RESET
  }
}


// WEBPACK FOOTER //
// ./src/actions/App.js